import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { TEXTAREA } from '../../../constants';
import { useInput } from '../../../hooks';
import { Context } from '../Context';
const Textarea = forwardRef((props, ref) => {
    const context = useContext(Context);
    const { inputProps, inputA11yProps } = useInput(context);
    return _jsx("textarea", { ref: ref, ...inputProps, ...inputA11yProps, ...props });
});
Textarea.displayName = TEXTAREA;
export { Textarea };
//# sourceMappingURL=Textarea.js.map